<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <h4>센터 검색</h4>

      <!-- 상단 UI : 왼쪽 에디트, 오른쪽 검색/닫기 -->
      <div class="top">
        <input v-model="keyword" type="text" placeholder="센터명" @keyup.enter="search" />
        <span class="spacer"></span>
        <button class="primary" :disabled="busy" @click="search">검색</button>
        <button class="ghost" @click="close">닫기</button>
      </div>

      <!-- 중간 UI : 검색 결과 표 (Header: 센터명, 총원) ※ 지원율 미표시 -->
      <div class="result-box">
        <table class="grid">
          <thead>
            <tr><th>센터명</th><th>총원</th></tr>
          </thead>
          <tbody>
            <tr v-for="c in list" :key="c.id" class="pick" @click="pick(c)">
              <td>{{ c.centerName }}</td>
              <td>{{ c.memberCnt != null ? c.memberCnt : 0 }}</td>
            </tr>
            <tr v-if="list.length===0"><td colspan="2" class="empty">검색 결과가 없습니다.</td></tr>
          </tbody>
        </table>
      </div>

      <!-- 페이징 (화면 공통 위젯) -->
      <Paging v-if="all.length > 0" :page="page" :size="size" :total-count="all.length" :total-pages="totalPages"
              @change-page="onPage" @change-size="onSize" />
      <p v-if="message" class="error">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import api from '../api';
import Paging from './Paging.vue';

export default {
  name: 'CenterSearchDialog',
  components: { Paging },
  data() { return { keyword: '', all: [], busy: false, message: '', page: 1, size: 10 }; },
  created() { this.search(); },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.all.length / this.size)); },
    list() {
      const s = (this.page - 1) * this.size;
      return this.all.slice(s, s + this.size);
    }
  },
  methods: {
    async search() {
      this.busy = true; this.message = ''; this.page = 1;
      try {
        const res = await api.centerSearch({ keyword: this.keyword });
        this.all = res.data || [];
      } catch (e) { this.message = e.message; }
      finally { this.busy = false; }
    },
    onPage(p) { this.page = p; },
    onSize(s) { this.size = s; this.page = 1; },
    pick(c) { this.$emit('select', c); },
    close() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 70; }
.modal { background: #fff; padding: 22px; border-radius: 8px; width: 460px; max-width: 94vw; }
.modal h4 { margin: 0 0 12px; }
.top { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.top input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; flex: 0 0 200px; }
.top .spacer { flex: 1; }
.top button { padding: 7px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; }
.top .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.top .ghost { background: #f5f5f5; }
.result-box { max-height: 320px; overflow: auto; border: 1px solid #eef; border-radius: 6px; }
.grid { width: 100%; border-collapse: collapse; }
.grid th, .grid td { border-bottom: 1px solid #eef; padding: 7px 9px; font-size: 13px; text-align: left; }
.grid th { background: #f0f3fa; position: sticky; top: 0; }
.grid tr.pick { cursor: pointer; }
.grid tr.pick:hover { background: #eef4ff; }
.empty { text-align: center; color: #999; padding: 14px; }
.error { font-size: 13px; color: #d93636; margin: 8px 0 0; }
small { color: #888; }
</style>
